module.exports = __webpack_public_path__ + "img/image84.550d3994.png";